module.exports = __webpack_public_path__ + "img/AG.2e69a547.svg";